import apiFetch from '../apiFetch'

export default function (token, roleId, force) {
  const queryString = force ? '?forceChecked=true' : ''
  return apiFetch({ endPoint: `role/${roleId}${queryString}`, method: 'DELETE', body: null, token: token })
}
